export const abnormalTypeEnum = {
  ABNORMAL_PRICE: 'ABNORMAL_PRICE',
  SUPER_ABNORMAL_PRICE: 'SUPER_ABNORMAL_PRICE',
  PRICE_TRANSFERRED: 'PRICE_TRANSFERRED',
  INCORRECT_VOLUME: 'INCORRECT_VOLUME',
  RECALCULATED: 'RECALCULATED',
  PRICE_RESTORED: 'PRICE_RESTORED',
  PRICE_TRANSLATED: 'PRICE_TRANSLATED'
} as const
